const AIRLINES = [
  'Turkish Airlines',
  'Georgian Airways',
  'Lufthansa',
  'LOT Polish Airlines',
  'AirBaltic',
  'Myway Airlines',
  'Easyjet',
  'Ryanair',
  'Wizz Air',
  'Pegasus Airlines',
  'Other',
  'Aegean Airlines',
  'Air France',
  'Al Italia',
  'Austrian Airlines',
  'Bulgaria Airline',
  'Croatia Airlines',
  'Dart Airlines',
  'Ellinair',
  'Eurowings',
  'Flydubai',
  'Hahn Air',
  'KLM',
  'Olympic AIr',
  'Qatar Airways',
  'Sun Express',
  'Swiss Airlines',
  'TAP AIr Portugal',
  'UIA Ukraine Airlines',
  'Vueling',
  'Yanair',
  'Finnair',
  'Virgin Atlantic',
  'Norwegian',
  'Flyone Armenia',
  'Flyone',
  'Condor Airline',
  'Buta airways',
  'Azerbaijan Airlines',
  'Sky Express'
];

export default AIRLINES;
